import React from "react";
import styled from "styled-components";
import { designTokens } from "../../styles/designTokens";

/**
 * BaseGlowProps: Glow 효과 컴포넌트 파라미터 정의 (transient props 사용)
 */
interface BaseGlowProps {
  $sizePx: number;
  $sizeVw: number;
  $leftPx: number;
  $leftVw: number;
  $leftFunc: "min" | "max";
  $topPx: number;
  $topVh: number;
  $topFunc: "min" | "max";
  $bg?: string;
  $opacity?: number;
  $blur?: number;
  $rotate?: string;
  $radius?: string;
}

/**
 * BaseGlow: 공통 Glow 효과 컴포넌트 (transient props로 DOM 전달 방지)
 */
const BaseGlow = styled.div<BaseGlowProps>`
  position: absolute;
  width: min(${(p) => p.$sizePx}px, ${(p) => p.$sizeVw}vw);
  height: min(${(p) => p.$sizePx}px, ${(p) => p.$sizeVw}vw);
  left: ${(p) => `${p.$leftFunc}(${p.$leftPx}px, ${p.$leftVw}vw)`};
  top: ${(p) => `${p.$topFunc}(${p.$topPx}px, ${p.$topVh}vh)`};
  background: ${(p) => p.$bg ?? "transparent"};
  opacity: ${(p) => p.$opacity ?? 1};
  filter: blur(${(p) => p.$blur ?? 0}px);
  border-radius: ${(p) => p.$radius ?? designTokens.borderRadius.full};
  transform: ${(p) => p.$rotate ?? "none"};
`;

const GlowContainer = styled.div`
  position: absolute;
  inset: 0;
  pointer-events: none;
`;

/**
 * Glow 효과 파라미터 목록 (transient props 사용)
 */
const glowEffects: BaseGlowProps[] = [
  {
    $sizePx: 395,
    $sizeVw: 30,
    $leftPx: -166,
    $leftVw: -10,
    $leftFunc: "min",
    $topPx: -251,
    $topVh: -20,
    $topFunc: "min",
    $bg: "#3758f9",
    $opacity: 0.11,
    $blur: 200,
  },
  {
    $sizePx: 263,
    $sizeVw: 20,
    $leftPx: -113,
    $leftVw: -8,
    $leftFunc: "min",
    $topPx: 769,
    $topVh: 70,
    $topFunc: "max",
    $bg: "linear-gradient(90deg, #e0c3fc 0%, #8ec5fc 100%)",
    $blur: 200,
  },
  {
    $sizePx: 1607.3,
    $sizeVw: 120,
    $leftPx: 703,
    $leftVw: 50,
    $leftFunc: "max",
    $topPx: 654.65,
    $topVh: 60,
    $topFunc: "max",
    $bg: "#bec4ff",
    $opacity: 0.3,
    $blur: 183.5,
    $rotate: "rotate(-30deg)",
    $radius: "20px",
  },
];

/**
 * GlowEffect 컴포넌트
 */
const GlowEffect: React.FC = () => (
  <GlowContainer>
    {glowEffects.map((props, idx) => (
      <BaseGlow key={idx} {...props} />
    ))}
  </GlowContainer>
);

export default GlowEffect;
